export const lob_overview_table = [
  { label: 'Status', value: 0 },
  { label: 'Month', value: 1 },
  { label: 'Year', value: 2 },
  { label: 'LOB', value: 3 },
  { label: 'Submit Date', value: 4 },
  { label: 'Submit By', value: 5 },
]
export const forecast_type = ['FIXFEE', 'TIME_MATERIAL', 'SUPPORT']

export const non_chargeable = ['COMMON', 'SPECIFIC']



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/constants.js